import { Navigate, useLocation } from "react-router-dom";
import { getStaffId, getAuthToken, consumeSessionExpired } from "../utils/storage";

const RequireAuth = ({ children }) => {
  const staffId = getStaffId();
  const token = getAuthToken();
  const location = useLocation();
  if (!staffId || !token) {
    if (consumeSessionExpired()) {
      return <Navigate to="/session-expired" replace />;
    }
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }
  return children;
};

export default RequireAuth;
